export default function initializeBubble(Vue) {
  Vue.directive('bubble', {
    bind: (el, binding, vnode) => {
      for (const event of Object.keys(binding.modifiers)) {
        if (vnode.componentInstance) {
          vnode.componentInstance.$on(event, (...args) => vnode.context.$emit(event, ...args));
        } else {
          el.addEventListener(event, (payload) => vnode.context.$emit(event, payload));
        }
      }
    },
  });
}